module.exports = __webpack_public_path__ + "c81d98ac54886ec692eddba665273567.png";